export default [
  {
    label: '通年営業',
    value: 'business_period',
  },
  {
    label: '年末年始営業',
    value: 'business_newyear',
  },
];
